<template>
    <div id="jsTree">
    </div>
</template>

<script>
export default {
    props:{
        disableUpdates:{
            type:Boolean,
            default:false,
        }
    },
    data(){
        return{
            disableChangedEvent:false,
            refreshThrottletimer: 0,
        };
    },
    mounted: function(){

        $('#jsTree').jstree({
            "core" : {
                "animation" : 0,
                "check_callback" : true,
                "themes" : { "stripes" : false },
                'data': Object.values(this.$store.getters.allFeatures).sort((aVal,bVal)=> aVal.sort_order - bVal.sort_order),
            },
            "types" : {
                "#" : {
                    //"max_children" : 1,
                    "max_depth" : 4,
                    "valid_children" : ["map"]
                },
                "map" : {
                    "icon" : "icon-map-o",
                    "valid_children" : ["block"]
                },
                "block" : {
                    "icon" : "icon-map",
                    "valid_children" : ["property"]
                },
                "property" : {
                    "icon" : "icon-map-pin",
                    "valid_children" : []
                }
            },
            "plugins" : [
                /*"contextmenu",*/ "dnd", /*"search",*/
                "state", "types", "wholerow", //'checkbox'
            ]
        });

        // listen for event and pass to vue method
        //$('#jsTree').on('select_node.jstree', (e, data)=>{
        $('#jsTree').on('changed.jstree', (e, data)=>{
            this.onTreeSelected(e, data);
        });

        // when refreshing the tree, we disable events.
        // once the tree is refreshed, we can re-enable them.
        $('#jsTree').on('refresh.jstree', (e)=>{
            this.disableChangedEvent = false;
        });

        // listen for node moved events and pass back to
        // Vue.js
        $('#jsTree').on('move_node.jstree', (e, data)=>{
            var nodes = $('#jsTree').jstree('get_json', '#', {flat:true});
            var sortOrders = new Map([]);
            nodes.forEach((val)=>{
                var node = $('#jsTree').jstree('get_node', val.id);
                // check sort order
                if (val.type == 'block'){
                    if (!sortOrders.has(val.parent)){
                        sortOrders.set(val.parent, 0);
                    }

                    sortOrders.set(val.parent, sortOrders.get(val.parent) + 10);
                    if (node.original.sort_order != sortOrders.get(val.parent)){
                        //node.original.sort_order = sortOrders.get(val.parent);
                        //node.original.hierarchyModified = true;
                        this.$store.commit('attribute',{id:val.id, attribute:'sort_order', value:sortOrders.get(val.parent)});
                        this.$store.commit('attribute', {id:val.id, attribute:'structureModified', value:true });
                    }
                }

                if (node.parent != node.original.parent){
                    //node.original.parent = node.parent;
                    //node.original.hierarchyModified = true;
                    this.$store.commit('attribute', {id:val.id, attribute:'parent', value:node.parent });
                    this.$store.commit('attribute', {id:val.id, attribute:'structureModified', value:true });
                }

            });
            this.$emit('node_moved', data);

        });

    },
    methods:{
        onTreeSelected(e, data){
            if (! this.disableChangedEvent){

                var selectedBlocks = []
                Object.values(this.$store.getters.allFeatures).forEach((val)=>{
                    var arraySelected = (!! data.selected.find((id)=>{return id == val.id}))
                    if (val.selected != arraySelected){
                        this.$store.commit('attribute', {id:val.id, attribute:'selected', value:arraySelected})
                    };
                });

                this.$emit('selection_changed', data.selected);
            }
        },
        refreshTreeData(){
            // throttle refreshes to (at most) once every half second
            clearTimeout(this.refreshThrottletimer);
            this.refreshThrottletimer = setTimeout(()=>{

                this.disableChangedEvent = true;
                var treeArray = Object.values(this.$store.getters.allFeatures).sort((itemA,itemB)=> itemA.sort_order - itemB.sort_order);
                $('#jsTree').jstree(true).settings.core.data = treeArray;

                treeArray.forEach(element => {
                    if (element.selected){
                        $('#jsTree').jstree('select_node', element.id, true);
                    } else {
                        $('#jsTree').jstree('deselect_node', element.id, true);
                    }
                });
                $('#jsTree').jstree('refresh');

            }, 500);
        }
    },
    computed:{
        allFeatures(){
            return this.$store.getters.allFeatures;
        }
    },
    watch: {
        disableUpdates: function(newVal, oldVal){
            if (! newVal){
                this.refreshTreeData();
            }
        },
        allFeatures: {
            handler: function(newVal, oldVal) { // watch it
                if (! this.disableUpdates){
                    this.refreshTreeData();
                }
            },
            deep:true,
        },
    },
}
</script>

<style>

</style>
